import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DEMO_USER } from "config/demoSession.ts";
import { jwtDecode } from "jwt-decode";
import type { RootState } from "app/store.ts";
import type { User } from "./authTypes.ts";

interface AuthSliceInitialState {
  user: User | null;
}

const token = sessionStorage.getItem("token") || null;
const isBypassActive = sessionStorage.getItem("loginBypass") === "true";

const initialState: AuthSliceInitialState = {
  user: token
    ? jwtDecode<User>(token)
    : isBypassActive
      ? DEMO_USER
      : null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<any>) => {
      state.user = jwtDecode<User>(action.payload.data.access_token);
    },
    setBypassUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    removeCredentials: (state) => {
      state.user = null;
    },
  },
});

export const { setBypassUser, setCredentials, removeCredentials } =
  authSlice.actions;

export const selectUser = (state: RootState) => state.auth.user;

export default authSlice.reducer;
